import * as THREE from "three";
import { pickingFragmentShader, pickingVertexShader } from "./shaders/picking";

export const pickingMaterial = new THREE.ShaderMaterial({
  name: "pickingMaterial",
  vertexShader: pickingVertexShader,
  fragmentShader: pickingFragmentShader,
  userData: { disableGrid: true },
  uniforms: {
    highlightedIds: { value: null },
    isolateMode: { value: false },
  },
});
